import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";

import HomePage2 from '../HomePage2/HomePage2';
import AboutPage from '../AboutPage/AboutPage';
import TestimonialPage from '../TestimonialPage/TestimonialPage';
import TestimonialPage2 from '../TestimonialPage2/TestimonialPage2';
import ServicePageS2 from '../ServicePageS2/ServicePageS2';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectPageS2 from '../ProjectPageS2/ProjectPageS2';
import ProjectSinglePage from '../ProjectSinglePage/ProjectSinglePage';
import BlogPage from '../BlogPage/BlogPage'
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide'
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull'
import FaqPage from '../FaqPage';
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import EmailPage from '../EmailPage/EmailPage';
import PricingPage from '../PricingPage/PricingPage';
import BookNowPage from '../BookNowPage/BookNowPage';


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage2 />} />
          <Route path="home" element={<HomePage2 />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="testimonials" element={<TestimonialPage />} />
          <Route path="testimonials-s2" element={<TestimonialPage2 />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="services" element={<ServicePageS2 />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="projects" element={<ProjectPage />} />
          <Route path="projects-s2" element={<ProjectPageS2 />} />
          <Route path="project-single/:slug" element={<ProjectSinglePage />} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog-left-sidebar' element={<BlogPageLeft />} />
          <Route path='blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='blog-single/:slug' element={<BlogDetails />} />
          <Route path='blog-single-left-sidebar/:slug' element={<BlogDetailsLeftSiide />} />
          <Route path='blog-single-fullwidth/:slug' element={<BlogDetailsFull />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='email' element={<EmailPage />} />
          <Route path='book-now' element={<BookNowPage />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
